import type { BadgeTone } from "./feedback";

/** Badge tone per status string; one table for every status shown in the app. */
const TONES: Record<string, BadgeTone> = {
  // messages
  accepted: "neutral",
  queued: "neutral",
  processing: "info",
  sent: "info",
  delivered: "success",
  deferred: "warning",
  bounced: "danger",
  failed: "danger",
  suppressed: "neutral",
  complained: "danger",
  subscribed: "success",
  unsubscribed: "warning",
  opened: "success",
  clicked: "success",
  // domains / records
  pending: "warning",
  verified: "success",
  disabled: "neutral",
  valid: "success",
  invalid: "danger",
  warning: "warning",
  // webhooks
  active: "success",
  failing: "warning",
  succeeded: "success",
  abandoned: "danger",
  // suppression reasons
  hard_bounce: "danger",
  soft_bounce: "warning",
  complaint: "danger",
  unsubscribe: "warning",
  manual: "neutral",
  // staff / risk / infrastructure
  sending_paused: "warning",
  open: "warning",
  acknowledged: "info",
  resolved: "success",
  critical: "danger",
  info: "info",
  healthy: "success",
  unhealthy: "danger",
  unknown: "neutral",
  draining: "warning",
  warming: "info",
  listed: "danger",
  spam_trap: "danger",
  // organizations
  pending_review: "warning",
  suspended: "danger",
  closed: "neutral",
  // billing
  pending_payment: "warning",
  past_due: "warning",
  trialing: "info",
  expired: "neutral",
  paid: "success",
  captured: "success",
};

export function statusTone(status: string): BadgeTone {
  return TONES[status] ?? "neutral";
}

export function humanize(value: string): string {
  const text = value.replace(/[_:.]/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
